export enum bandStates {
    warning = 'TEMPERATURE WARNING',
    caution = 'TEMPERATURE CAUTION',
    indeterminate = 'INDETERMINATE',
    lowBattery = 'LOW BATTERY',
    offline = 'OFFLINE',
    unworn = 'NOT WORN',
    newWearer = 'NEW WEARER',
    noStatus = 'NO STATUS'
}